// extracted by mini-css-extract-plugin
export default {"blockwrapper":"IT","header":"JT","name":"KT","columns":"LT","imagewrapper":"MT","addinfo":"NT","description":"OT","price":"PT","old":"QT","new":"RT","desc_d":"ST","infoblock":"TT","desc_m":"UT"};
    if(module.hot) {
      // 1743628928008
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  